<template>
  <FlexboxLayout class="loader" justifyContent="center" alignContent="center" role="status" aria-live="polite" aria-label="Daten werden geladen">
    <ActivityIndicator busy="true" :color="color" aria-hidden="true" />
    <span class="sr-only">Daten werden geladen...</span>
  </FlexboxLayout>
</template>

<script>

import { colors } from '@/helpers/ui'

export default {
  props: {
    color: {
      type: String,
      default: colors.primary
    }
  }
}

</script>